// src/components/ui/StatusBadge.jsx
import React from "react";

const StatusBadge = ({ status }) => {
  const getStatusClass = (status) => {
    return status === "Active"
      ? "bg-success-focus text-success-600 border border-success-main"
      : "bg-danger-focus text-danger-600 border border-danger-main";
  };

  return (
    <span
      className={`px-24 py-4 radius-4 fw-medium text-sm ${getStatusClass(
        status
      )}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
